import { Component } from "@angular/core";
declare const BrandVars;

@Component({
	selector: "app-footer",
	templateUrl: "./footer.component.html",
	styleUrls: ["./footer.component.scss"]
})
export class FooterComponent {
	public brand = BrandVars;
	public year = new Date().getFullYear();

}
